export default __webpack_public_path__ + "static/PR2-735677d356316fffa50b01e29ea22955.jpg";